import type { CountryCode } from '../../../../apis/graphql';
import type { Asset2Extended } from '../../../../models';

export function getCountryCodesFromAsset(asset?: Asset2Extended): string[] {
  if (!asset?.countryCodes?.length) return [];

  return asset.countryCodes.filter((countryCode): countryCode is CountryCode => !!countryCode);
}
